// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__EKhBr","label":"Labeled_label__2uIqW","divider":"Labeled_divider__m5SJU"};